import AuthService from "../services/AuthService";
import { jwtDecode } from 'jwt-decode';

class AuthController {
  async handleGoogleLogin(credentialResponse) {
    try {
      // Validar que tenemos el credential
      if (!credentialResponse?.credential) {
        throw new Error('Token de Google no recibido');
      }

      // Decodificar token de Google para obtener datos del usuario
      let googleUserData;
      
      // Limpiar el token de posibles caracteres problemáticos
      const cleanToken = credentialResponse.credential.trim().replace(/\s+/g, '');
      
      try {
        // Intentar con jwt-decode primero
        googleUserData = jwtDecode(cleanToken);
        console.log('✅ Token decodificado con jwt-decode');
      } catch (jwtDecodeError) {
        console.warn('⚠️ jwt-decode falló, intentando decodificación manual:', jwtDecodeError.message);
        
        // Fallback a decodificación manual con mejor manejo de caracteres
        try {
          const parts = cleanToken.split('.');
          if (parts.length !== 3) {
            throw new Error('Token JWT no tiene 3 partes');
          }
          
          let base64Payload = parts[1];
          
          // Limpiar caracteres problemáticos adicionales
          base64Payload = base64Payload.replace(/[^A-Za-z0-9+/\-_]/g, '');
          
          // Convertir base64url a base64 estándar
          let base64 = base64Payload.replace(/-/g, '+').replace(/_/g, '/');
          
          // Agregar padding si es necesario
          const padding = base64.length % 4;
          if (padding) {
            base64 += '='.repeat(4 - padding);
          }
          
          // Decodificar con manejo de errores mejorado
          let decodedPayload;
          try {
            decodedPayload = atob(base64);
          } catch (atobError) {
            // Intentar con escape de caracteres especiales
            const escapedBase64 = base64.replace(/[^A-Za-z0-9+/=]/g, '');
            decodedPayload = atob(escapedBase64);
          }
          
          // Limpiar caracteres de control antes de parsear JSON
          const cleanPayload = decodedPayload.replace(/[\x00-\x1F\x7F]/g, '');
          googleUserData = JSON.parse(cleanPayload);
          
          console.log('✅ Token decodificado con fallback manual mejorado');
        } catch (manualDecodeError) {
          console.error('❌ Error en ambos métodos de decodificación:', {
            jwtDecodeError: jwtDecodeError.message,
            manualDecodeError: manualDecodeError.message,
            tokenSample: cleanToken.substring(0, 100) + '...'
          });
          
          // Último intento: enviar token sin decodificar al backend
          console.warn('🔄 Enviando token sin decodificar al backend');
          googleUserData = { email: 'unknown', name: 'Usuario' };
        }
      }



      // Llamar al servicio de autenticación
      const response = await AuthService.loginWithGoogle(
        credentialResponse.credential
      );

      if (response?.token) {
        // Combinar datos del backend con nombre de Google
        const userData = response.user && typeof response.user === 'object' 
          ? {
              ...response.user,
              name: googleUserData.name,  // Siempre usar nombre de Google
              nombre: googleUserData.name  // También actualizar campo nombre
            }
          : {
              id: response.user,
              name: googleUserData.name,
              email: googleUserData.email,
              picture: googleUserData.picture,
            };

        // Guardar datos de autenticación
        AuthService.saveAuthData(userData, response.token);

        return { success: true, userData, token: response.token };
      } else {
        throw new Error("Respuesta del servidor inválida");
      }
    } catch (error) {
      console.error("Login controller error:", error);
      
      // Determinar el tipo de error y proporcionar mensaje apropiado
      let errorMessage = error.message;
      
      if (error.message.includes('fetch')) {
        errorMessage = 'No se pudo conectar al servidor';
      } else if (error.message.includes('network')) {
        errorMessage = 'Error de red. Verifica tu conexión';
      } else if (!errorMessage || errorMessage === 'Login failed') {
        errorMessage = 'Error de autenticación. Intenta nuevamente';
      }
      
      return {
        success: false,
        error: errorMessage,
      };
    }
  }

  async handleLogout() {
    try {
      await AuthService.logout();
      return { success: true };
    } catch (error) {
      console.error("Logout controller error:", error);
      return { success: false, error: error.message };
    }
  }

  getCurrentUser() {
    return AuthService.getStoredUser();
  }

  isAuthenticated() {
    return AuthService.isAuthenticated();
  }
}

export default new AuthController();
